export default function Footer() {
  const groups = [
    {
      title: "内容",
      links: ["影视雷达", "现场回声", "商业切片", "人物访谈"],
    },
    {
      title: "官方",
      links: ["官方渠道", "关于我们", "资质认证", "版权声明"],
    },
    {
      title: "服务",
      links: ["联系客服", "商务合作", "创作者入驻", "广告投放"],
    },
  ];

  return (
    <footer className="bg-secondary-100/50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-12">
          {/* brand col */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-newspaper-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                  吃瓜官网
                </span>
                <span className="text-[11px] tracking-widest text-foreground-500">
                  CHIGUA OFFICIAL
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-600">
              以严谨内容回应好奇心的资讯平台。本页为吃瓜官网官方渠道、客服与商务合作的
              统一入口，欢迎通过官方渠道获取更多服务。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-700">
                <i className="ri-verified-badge-fill text-primary-600"></i>
                企业认证
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-700">
                <i className="ri-shield-check-line text-accent-600"></i>
                内容合规
              </span>
            </div>
          </div>

          {/* link columns */}
          {groups.map((g) => (
            <div key={g.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-foreground-950">{g.title}</h4>
              <ul className="mt-4 space-y-3">
                {g.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* contact mini */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold text-foreground-950">直连</h4>
            <ul className="mt-4 space-y-3">
              {[
                { icon: "ri-mail-line", label: "邮箱", href: "#contact" },
                { icon: "ri-phone-line", label: "热线", href: "#contact" },
                { icon: "ri-wechat-2-line", label: "微信", href: "#channels" },
              ].map((c) => (
                <li key={c.label}>
                  <a
                    href={c.href}
                    className="flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className={c.icon}></i>
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜官网 · 本页为静态示例展示，不接接口与真实提交
          </p>
          <p className="text-xs text-foreground-400">
            <i className="ri-safe-2-line mr-1"></i>
            谨防仿冒 · 认准官方渠道
          </p>
        </div>
      </div>
    </footer>
  );
}